// extracted by mini-css-extract-plugin
export var subtitle = "_cs-2";
export var title = "_cs-0";
export var titleNoWrap = "_cs-1";